document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.home-section--title').forEach((title) => {
        const text = title.textContent.trim(); // Get the text and trim whitespace
        const lastSpaceIndex = text.lastIndexOf(' ');

        if (lastSpaceIndex !== -1) {
            // For multiple-word titles
            const beforeLastWord = text.slice(0, lastSpaceIndex);
            const lastWord = text.slice(lastSpaceIndex + 1);
            title.innerHTML = `${beforeLastWord} <span class="highlight">${lastWord}</span>`;
        } else if (text) {
            // For single-word titles
            title.innerHTML = `<span class="highlight">${text}</span>`;
        }
    });
});


document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".product-slider");
  const slides = document.querySelectorAll(".product-slide");
  const nextButton = document.querySelector(".slider-next");
  const prevButton = document.querySelector(".slider-prev");

  if (!slider || slides.length === 0 || !nextButton || !prevButton) {
    console.error("Slider or buttons not found. Ensure the HTML structure is correct.");
    return;
  }

  // Get the width of a single slide dynamically
  const slideWidth = slides[0].offsetWidth;

  // Add event listeners for the buttons
  nextButton.addEventListener("click", () => {
    slider.scrollBy({
      left: slideWidth,
      behavior: "smooth",
    });
  });

  prevButton.addEventListener("click", () => {
    slider.scrollBy({
      left: -slideWidth,
      behavior: "smooth",
    });
  });

  console.log("Slider and buttons initialized successfully.");
});


//seo collection description read more accordion 
document.addEventListener("DOMContentLoaded", function () { 
    document.querySelectorAll("#shopify-section-template--24130137293085__dynamic_rich_text_Hizfri .metafield-rich_text_field p, .metafield-rich_text_field p").forEach(paragraph => {
        const fullHTML = paragraph.innerHTML.trim();
        const charLimit = 300;

        if (fullHTML.length > charLimit) {
            const shortHTML = fullHTML.substring(0, charLimit) + "...";

            // Wrap text inside divs to preserve formatting
            paragraph.innerHTML = `<div class="text-preview">${shortHTML}</div>
                                   <div class="full-text hidden">${fullHTML}</div>
                                   <a href="#" class="read-more">Read More</a>`;

            const readMoreLink = paragraph.querySelector(".read-more");
            readMoreLink.addEventListener("click", function (event) {
                event.preventDefault();
                const preview = paragraph.querySelector(".text-preview");
                const full = paragraph.querySelector(".full-text");

                if (full.classList.contains("hidden")) {
                    preview.style.display = "none";
                    full.classList.remove("hidden");
                    readMoreLink.textContent = "Read Less";
                } else {
                    preview.style.display = "block"; // Ensure paragraph breaks return
                    full.classList.add("hidden");
                    readMoreLink.textContent = "Read More";
                }
            });
        }
    });
});


